import Api from '../../../services/Api'
import moment from 'moment'

import {
    SET_USER,
    LOGOUT,
    MESSAGE
} from '../../actions/session'

import { currentEnvName } from '../../../constants/env'

const initialSessionState = {
    email: null,
    id: null,
    locale: null,
    env: null,
    token: null,
    token_expire_at: null,
    isNew: false,
    message: null
}

export const init = () => {
    const current_auth = localStorage.getItem("sheetgo_current_token")
    console.log('[Auth:SessionReducer] init — localStorage token present:', !!current_auth)
    if (current_auth) {
        const data_token = JSON.parse(new Buffer(current_auth, 'base64').toString())
        console.log('[Auth:SessionReducer] init — decoded data_token:', data_token)
        console.log('[Auth:SessionReducer] init — token field:', data_token?.token, '| env:', data_token?.env, '| expires:', data_token?.token_expire_at)
        if (data_token) {
            if (!data_token.token) {
                console.warn('[Auth:SessionReducer] init — stored data has no token field (likely an error response was stored), clearing localStorage')
                localStorage.removeItem("sheetgo_current_token")
                return initialSessionState
            }

            const isExpired = moment(data_token.token_expire_at).isBefore()
            console.log('[Auth:SessionReducer] init — isExpired:', isExpired)
            if (isExpired) {
                console.warn('[Auth:SessionReducer] init — token expired, resetting state')
                return initialSessionState
            }

            if (!data_token.env || (data_token.env !== currentEnvName)) {
                console.warn('[Auth:SessionReducer] init — env mismatch (stored:', data_token.env, ', current:', currentEnvName, '), resetting state')
                return initialSessionState
            }

            setTimeout(() => {
                console.log('[Auth:SessionReducer] init — calling getRefreshToken with token:', data_token.token)
                const SheetgoAPI = new Api({ token: data_token.token })
                SheetgoAPI.getRefreshToken()
            }, 0)

            return {
                ...initialSessionState,
                ...data_token
            }
        } else {
            console.warn('[Auth:SessionReducer] init — data_token parsed as falsy')
            return initialSessionState
        }
    } else {
        console.log('[Auth:SessionReducer] init — no stored token, using initial state')
        return initialSessionState
    }
}

export function reducer(state = init(), action) {
    switch (action.type) {
        case SET_USER:
            try {
                console.log('[Auth:SessionReducer] SET_USER — action.payload:', action.payload)
                const toEncode = {
                    ...action.payload,
                    ...{
                        env: currentEnvName
                    }
                }
                console.log('[Auth:SessionReducer] SET_USER — toEncode (what goes to localStorage):', toEncode)
                const encodedToken = new Buffer(JSON.stringify(toEncode)).toString('base64')
                localStorage.setItem("sheetgo_current_token", encodedToken)
                return {
                    ...state,
                    ...toEncode
                }
            } catch (e) {
                console.error('SET_USER', e)
                return state
            }
        case MESSAGE:
            try {
                return {
                    ...state,
                    ...{
                        message: action.message
                    }
                }
            } catch (e) {
                console.error('MESSAGE', e)
                return state
            }
        case LOGOUT:
            try {
                localStorage.removeItem("sheetgo_current_token")
                return initialSessionState
            } catch (e) {
                console.error('LOGOUT', e)
                return state
            }
        default:
            return state
    }
}